import { render, staticRenderFns } from "./NourishQR.vue?vue&type=template&id=7557d896&scoped=true"
var script = {}
import style0 from "./NourishQR.vue?vue&type=style&index=0&id=7557d896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7557d896",
  null
  
)

export default component.exports